module.exports = __webpack_public_path__ + "img/iphone-charging-UK-en.d7ba3501.png";